import { styled, css } from 'styled-components'

import { COLORS } from 'consts/colors'

export const UserAvatar = styled.div<{
  $isHovered?: boolean
  $data: {
    background: string
    url: string
  }
}>`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-image: ${({ $data: { background, url } }) =>
    `url(${url}), ${background}`};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid ${COLORS.white};
  box-shadow: 0 0 0 1px ${COLORS.secondaryLight};
  transition: box-shadow 0.2s;
  flex-shrink: 0;

  ${({ $isHovered }) =>
    $isHovered &&
    css`
      box-shadow: 0 0 0 1px ${COLORS.secondarySemiDark};
    `}
`
